import { Routes } from '@angular/router';
import { HeroIngredientEditComponent } from './edit/hero-ingredient-edit.component'
import { HeroIngredientViewComponent } from './view/hero-ingredient-view.component'
import { HeroIngredientListComponent } from './list/hero-ingredient-list.component'
import { HeroIngredientResolve } from './hero-ingredient-resolver'

export const heroIngredientRoutes: Routes = [
  {
    path: '',
    component: HeroIngredientListComponent,
    pathMatch: 'full'
  },
  { path: 'new',
    component: HeroIngredientEditComponent,
    pathMatch: 'full'
  },
  { path: ':id/edit',
    component: HeroIngredientEditComponent,
    pathMatch: 'full',
    resolve: { heroIngredient: HeroIngredientResolve }, providers: [HeroIngredientResolve]
  },
  { path: ':id',
    component: HeroIngredientViewComponent,
    pathMatch: 'full',
    resolve: { heroIngredient: HeroIngredientResolve },
    providers: [HeroIngredientResolve]
  },
];
